module.exports = __webpack_public_path__ + "img/spa.0cc1eb9b.png";